<template>
  <ComponentsLayoutWithNavbar
    id="supplier-item"
    main_color="var(--color-main-green)"
    with_footer>
    <template #breadcrumbs>
      <Breadcrumbs
        class="pa-0"
        :items="breadcrumbs"/>
    </template>
    <template #main_content>
      <div
        class="flex flex-between width-100">
        <v-skeleton-loader
          v-if="loading"
          class="pt-4 pl-5"
          type="heading"
          width="300px"/>
        <v-card-title
          v-else
          class="pt-5 h1-headline pl-0"
          data-qa="organizationTitle">
          {{ item.organizationTitle }}
        </v-card-title>
        <v-card-actions>
          <RatingDialog
            :organization-id="item.supplierOrganizationId"
            :organization-title="item.organizationTitle"
            :type-ratings.sync="typeRatings"
            @changeRatings="$refs.supplierRating ? $refs.supplierRating.getRatings() : ''"/>
        </v-card-actions>
      </div>
      <div class="width-100 py-8">
        <v-tabs
          v-model="tab"
          background-color="main__green"
          class="supplier-tabs tabs mb-3"
          color="var(--black-color)"
          data-qa="tabs">
          <v-tab
            v-for="tabItem in tabs"
            :key="tabItem.name"
            class=" px-3 h7-text-medium text-uppercase tab mr-4 tab-name"
            :data-qa="'tab-select-'+ tabItem.value">
            {{ tabItem.name }}
            <div
              v-if="tabItem.count"
              class="tab__badge h9-text-bold black--text'">
              <span> {{ tabItem.count }} </span>
            </div>
          </v-tab>
        </v-tabs>
        <v-tabs-items
          v-model="tab"
          class="main__green">
          <v-tab-item
            class="bi-tab"
            data-qa="tab-bi">
            <div class="main__light_green bi-tab_card pa-5">
              <div class="text-left pb-3 h7-text-medium text-uppercase">
                {{ $t('Suppliers.PopularSupplierCategories') }}
              </div>
              <sDivider/>
              <div class="bi-tab_card-chart py-3">
                <template
                  v-if="!loading">
                  <div
                    v-if="!categories.length"
                    class="h2-headline-medium black--text my-5">
                    {{ $t('Common.NoDataInCurrentDateRange') }}
                  </div>
                  <SpilkaChartsMF
                    v-else-if="growthBook.mf_apex"
                    v-bind="donutMfPayload"
                    height="280"/>
                  <ApexChartDonut
                    v-else
                    :chart-options="chartOptions"
                    height="280"
                    :series="series"/>
                </template>
                <div
                  v-else
                  class="flex">
                  <div>
                    <v-skeleton-loader
                      class="pt-4 pl-5"
                      height="100%"
                      type="image"/>
                  </div>
                  <div class="width-30">
                    <v-skeleton-loader
                      v-for="(i, n) in new Array(10)"
                      :key="n"
                      class="mt-3 px-8"
                      height="20px"
                      type="text"/>
                  </div>
                  <div class="width-30">
                    <v-skeleton-loader
                      v-for="(i, n) in new Array(10)"
                      :key="n"
                      class="mt-3 px-8"
                      height="20px"
                      type="text"/>
                  </div>
                </div>
              </div>
              <sDivider/>
              <div class="pt-4 flex flex-between align-center">
                <sRadioGroup
                  v-model="top_by"
                  data-qa="suppliers-active-changeTop"
                  row
                  @change="changeTop">
                  <sRadio
                    data-qa="suppliers-sum"
                    label="summ">
                    {{ $t('Suppliers.Sum') }}
                  </sRadio>
                  <sRadio
                    data-qa="suppliers-quantity"
                    label="quantity">
                    {{ $t('Suppliers.Quantity') }}
                  </sRadio>
                </sRadioGroup>
                <div
                  class="flex align-center"
                  data-qa="supplier-date-range">
                  <div
                    class="mr-2 h7-text"
                    data-qa="suppliers-showForPeriod">
                    {{ $t('Suppliers.ShowForPeriod') }}:
                  </div>
                  <DateRangeDialogWithType
                    data-qa="supplier-chart-period"
                    placeholder="Оберіть дату"
                    :search.sync="period"
                    show-periods
                    value-type="YYYY-MM-DD"
                    @apply="getParticipationByTenderCategory"/>
                </div>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item
            class="contact_persons-tab"
            data-qa="tab-contact_persons">
            <SupplierContactPeople v-if="tabs[tab] && tabs[tab].value == 'contact_persons'"/>
          </v-tab-item>
          <v-tab-item
            class="tenders-tab"
            data-qa="tab-tenders">
            <SupplierTenders v-if="tabs[tab] && tabs[tab].value == 'tenders'"/>
          </v-tab-item>
          <v-tab-item
            class="offers-tab"
            data-qa="tab-offers">
            <SupplierOffers v-if="tabs[tab] && tabs[tab].value == 'offers'"/>
          </v-tab-item>
          <v-tab-item>
            <SupplierRating
              ref="supplierRating"
              :item-rating="item.rating"
              :organization-id="item.supplierOrganizationId"
              :organization-title="item.organizationTitle"
              :type-ratings.sync="typeRatings"/>
          </v-tab-item>
          <v-tab-item>
            <EmptyBlock
              v-if="!attachments.length"
              custom-class="mt-0 pa-10 no-docs"
              data-qa="document-noData"
              :text="$t('Tenders.NoData')">
              <template #append>
                <sButton
                  class="block mt-5"
                  @click="showDecisionForm(true)">
                  {{ $t('Tenders.ToAddDocs') }}
                </sButton>
              </template>
            </EmptyBlock>
            <DocumentList
              v-else
              :attachments="attachments"
              can_delete
              :new-endpoints="true"
              small/>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </template>
    <template #nav_bar="{ mini }">
      <v-container
        v-show="!mini"
        class="supplier-info pa-0 main__light_green flex">
        <template v-if="loading">
          <v-skeleton-loader
            class="mt-10 px-8"
            height="50px"
            type="heading"
            width="80%"/>
          <v-skeleton-loader
            v-for="(i, n) in new Array(3)"
            :key="n"
            class="mt-3 px-8"
            height="50px"
            type="sentences"
            width="100%"/>
        </template>
        <v-list
          v-else
          class="pt-1 pb-3 info-list text-left"
          :class="details ? 'details' : 'nodetails'">
          <div class="flex flex-between px-4">
            <div
              class="h3-headline pl-1 my-auto text-left"
              data-qa="suppliers-aboutSupplier">
              {{ $t('StopLists.AboutSupplier') }}
            </div>
            <div class="my-3">
              <v-menu
                content-class="supplier-options-menu menu"
                left
                :min-width="100"
                offset-x
                offset-y>
                <template #activator="{ on }">
                  <div
                    class="ml-auto"
                    v-on="on"
                    @click.prevent="">
                    <sButton
                      class="mr-3"
                      icon="menu"
                      icon-size="16px"
                      small
                      type="text"/>
                  </div>
                </template>
                <div>
                  <MenuItem
                    data-qa="menu-item-revision"
                    :disabled="$acl.get.includes('tenders_view')"
                    icon="edit"
                    :label="item.revisionStatus != 'VERIFIED' ? $t('Suppliers.AddVerificationInformation') : $t('Suppliers.ChangeInspectionDecision')"
                    @click="showDecisionForm(false)"/>
                  <MenuItem
                    data-qa="href-youcontrol"
                    :href="`https://youcontrol.com.ua/ru/search/?country=1&q=${item.egrpou}`"
                    icon="share"
                    :label="$t('Suppliers.GotoYouControl')"
                    target="_blank"/>
                  <MenuItem
                    v-if="item.egrpou.length < 10"
                    data-qa="href-opendatabot"
                    :href="`https://opendatabot.ua/c/${item.egrpou}`"
                    icon="share"
                    :label="$t('Suppliers.GotoOpenDataBot')"
                    target="_blank"/>
                  <MenuItem
                    data-qa="added-documents"
                    icon="add-file"
                    :label="$t('Tenders.ToAddDocs')"
                    @click="showDecisionForm(true)"/>
                </div>
              </v-menu>
            </div>
          </div>
          <div class="px-4 py-2">
            <div>
              {{ $t('Purchasing.Status') }}
            </div>
            <StatusChip
              class="mr-5"
              key-name="verificationStatusId"
              :status="status"
              value-name="title"/>
            <sTooltip
              v-if="item.revisionStatus == 'VERIFIED'"
              :key="item.revisionStatus"
              :border="false"
              class="mr-2">
              <StatusChip
                data-qa="decision-status1111"
                key-name="decisionTypeId"
                :status="decision_status"
                value-name="title"/>
              <div
                slot="content">
                <div
                  class="h9-label px-0"
                  data-qa="verified">
                  {{ $t('Suppliers.VERIFIED') }}:
                </div>
                <div
                  class="h8-text px-0 text-start"
                  data-qa="verified-inspectorFullName">
                  {{ item.inspectorFullName }}
                </div>
                <div
                  class="h8-text px-0 text-start"
                  data-qa="verified-revisionDate">
                  {{ formatBy( item.revisionDate , 'DD.MM.YYYY') }}
                </div>
              </div>
            </sTooltip>
          </div>
          <template v-if="item.revisionStatus == 'VERIFIED'">
            <v-list-item class="">
              <v-list-item-content class="py-2">
                <v-list-item-subtitle class="h9-label px-0">
                  {{ $t('Suppliers.Relevance') }}
                </v-list-item-subtitle>
                <v-list-item-title
                  class="h7-text"
                  data-qa="relevance-statusActualTo">
                  {{ formatBy( item.statusActualTo , 'DD.MM.YYYY') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="">
              <v-list-item-content class="py-2">
                <v-list-item-subtitle class="h9-label px-0">
                  {{ $t('Suppliers.Comment') }}
                </v-list-item-subtitle>
                <v-list-item-title data-qa="relevance-Comment">
                  {{ item.revisionComment || '–' }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-row no-gutters>
            <v-col>
              <v-list-item class="">
                <v-list-item-content class="py-2">
                  <v-list-item-subtitle class="h9-label px-0">
                    {{ $t('Tenders.EDRPOU') }}
                  </v-list-item-subtitle>
                  <v-list-item-title data-qa="egrpou">
                    {{ item.egrpou }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col>
              <v-list-item class="">
                <v-list-item-content class="py-2">
                  <v-list-item-subtitle class="h9-label">
                    {{ $t('Tenders.Rating') }}
                  </v-list-item-subtitle>
                  <v-list-item-title data-qa="rating">
                    {{ item.rating || '–' }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <SupplierOnSite
            class="px-4 ma-0"
            :supplier="item"/>
          <template v-if="details">
            <v-list-item v-if="item.bids">
              <v-list-item-content class="py-2">
                <v-list-item-subtitle class="h9-label px-0">
                  {{ $t('Suppliers.Activity') }}
                </v-list-item-subtitle>
                <v-list-item-title
                  class="h7-text"
                  data-qa="suppliers-activity">
                  <div class="all-ofers">
                    <span
                      class="bold all-offers-count"
                      data-qa="all-offers-count"> {{ formSum(item.bids.count) }} {{ $t('Tenders.Offers') }}</span>
                    {{ $t('Suppliers.FiledForTotalAmount') }}
                    <span
                      class="bold all-offers-amount"
                      data-qa="all-offers-amount"> {{ formSum(item.bids.pricesSum) }} {{ $t('Tenders.hrn') }}</span>
                  </div>
                  <div class="on-my-org-ofers">
                    {{ $t('Suppliers.FromThem') }}
                    <span
                      class="bold on-my-org-offers-count"
                      data-qa="on-my-org-offers-count"> {{ formSum(item.bids.countInOwnTender) }} {{ $t('Tenders.Offers') }}</span>
                    {{ $t('Suppliers.OnTendersOfMyOrganizationForSumOf') }}
                    <span
                      class="bold on-my-org-offers-amount"
                      data-qa="on-my-org-offers-amount"> {{ formSum(item.bids.pricesSumInOwnTender) }} {{ $t('Tenders.hrn') }}</span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="item.wins">
              <v-list-item-content class="py-2">
                <v-list-item-subtitle class="h9-label px-0">
                  {{ $t('Suppliers.Achievement') }}
                </v-list-item-subtitle>
                <v-list-item-title
                  class="h7-text"
                  data-qa="suppliers-achievement">
                  <div class="all-wins">
                    <span
                      class="bold all-wins-count"
                      data-qa="all-wins-count"> {{ formSum(item.wins.count) }} {{ $t('Suppliers.OfVictories') }}</span>
                    {{ $t('Suppliers.FiledForTotalAmount') }}
                    <span
                      class="bold all-wins-amount"
                      data-qa="all-wins-amount"> {{ formSum(item.wins.pricesSum) }} {{ $t('Tenders.hrn') }}</span>
                  </div>
                  <div class="on-my-org-wins">
                    {{ $t('Suppliers.FromThem') }}
                    <span
                      class="bold on-my-org-wins-count"
                      data-qa="on-my-org-wins-count"> {{ formSum(item.wins.countInOwnTender) }} {{ $t('Suppliers.OfVictories') }}</span>
                    {{ $t('Suppliers.OnTendersOfMyOrganizationForSumOf') }}
                    <span
                      class="bold on-my-org-wins-amount"
                      data-qa="on-my-org-wins-amount"> {{ formSum(item.wins.pricesSumInOwnTender) }} {{ $t('Tenders.hrn') }}</span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="">
              <v-list-item-content class="py-2">
                <v-list-item-subtitle class="h9-label px-0">
                  {{ $t('Suppliers.NumberOfLocks') }}
                </v-list-item-subtitle>
                <v-list-item-title data-qa="blockingCount">
                  {{ item.blockingCount }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="">
              <v-list-item-content class="py-2">
                <v-list-item-subtitle class="h9-label px-0">
                  {{ $t('Suppliers.Note') }}
                </v-list-item-subtitle>
                <v-list-item-title data-qa="remark">
                  {{ item.remark || '–' }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-container>

      <SupplierInspectionDecisionModal
        v-if="!$acl.get.includes('tenders_view')"
        :only-files="decisionForm.onlyFiles"
        :show.sync="decisionForm.show"
        :supplier="item"
        @addedNewFile="addedNewFile"
        @deleteFile="deleteFile"
        @updateItem="getItem"/>
    </template>
    <template #footer>
      <router-link
        key="footer"
        class="ml-auto"
        :to="parrent ? parrent : {name: 'suppliers'}">
        <sButton
          class=" h7-text px-4 py-2 back-btn"
          data-qa="btn-back"
          type="text">
          <sIcon
            class="s-btn-icon"
            rotate="90"
            size="10"
            type="long-arrow"/>
          {{ $t('Common.Back') }}
        </sButton>
      </router-link>
    </template>
  </ComponentsLayoutWithNavbar>
</template>

<script>
import MenuItem from 'components/common/MenuItem.vue'
import ApexChartDonut from 'components/charts/ApexChartDonut.vue'
import SpilkaChartsMF from 'components/common/SpilkaChartsMF.vue'
import EmptyBlock from 'components/common/elements/EmptyBlock.vue'
import StatusChip from 'components/common/elements/StatusChip.vue'
import SupplierOffers from 'components/supplies/SupplierOffers.vue'
import SupplierRating from 'components/supplies/SupplierRating.vue'
import SupplierOnSite from 'components/supplies/SupplierOnSite.vue'
import DocumentList from 'components/common/blocks/DocumentList.vue'
import Breadcrumbs from 'components/common/elements/Breadcrumbs.vue'
import RatingDialog from 'components/common/dialogs/RatingDialog.vue'
import SupplierTenders from 'components/supplies/SupplierTenders.vue'
import SupplierContactPeople from 'components/supplies/SupplierContactPeople.vue'
import ComponentsLayoutWithNavbar from 'pages/templates/ComponentsLayoutWithNavbar.vue'
import DateRangeDialogWithType from 'components/common/dialogs/DateRangeDialogWithType.vue'
import SupplierInspectionDecisionModal from 'components/supplies/SupplierInspectionDecisionModal.vue'

import { modalMixin, supplierMixin } from 'mixins'

import FilesApi from '@/api/filesApi'
const files_api = new FilesApi()

import { StorageFile } from '@/types/commonFile.js'

/**
* @vue-data {Array} headers - Заголовки таблицы с данными рейтингов
*/
export default {
  name: 'supplier',
  mixins: [ modalMixin, supplierMixin ],
  data() {
    return {
      loading: false,
      item: {},
      org: {},
      tab: 0,
      parrent: null,
      categories: [],
      period: [this.$moment().startOf('year').format('YYYY-MM-DD'), this.$moment().endOf('year').format('YYYY-MM-DD')],
      top_by: 'summ',
      details: true,
      typeRatings: [],
      attachments: [],
      decisionForm: {
        show: false,
        onlyFiles: false
      },
      showDocumentModal: false,
    }
  },
  async created() {
    if ( this.$route?.query?.tab ) {
      const indexTab = this.tabs.findIndex(i => i.value === this.$route?.query?.tab)
      if (indexTab !== -1) {
        this.tab = indexTab
      }
      this.$router.replace('')
    }

    if (this.$route?.query?.tenderId) {
      this.parrent = {
        name: 'tenderitem',
        params: {
          id: this.$route?.query?.tenderId,
          org: this.$route.params.org
        },
        query: { tab: 'offers'}
      }
      this.$router.replace('')
    }
    this.loading = true
    this.$store.dispatch('getCrmVerificationFillingInfo')
    // await this.$store.dispatch('getOrganizationInfo', this.$route.params.id).then(res => {
    //   this.org = res[0]
    // })
    await this.getItem()

    this.getParticipationByTenderCategory()

    await this.fetchAttachments()

    this.loading = false
  },
  computed: {
    tabs() {
      return [
        {
          name: 'BI',
          value: 'BI',
        },
        {
          name: this.$t('Tenders.ContactPersons'),
          value: 'contact_persons',
        },
        {
          name: this.$t('Tenders.Tenders'),
          value: 'tenders',
        },
        {
          name: this.$t('Tenders.Offers'),
          value: 'offers',
        },
        {
          name: this.$t('Tenders.Rating'),
          value: 'rating',
        },
        {
          name: this.$t('Tenders.Documents'),
          value: 'documents',
          count: this.attachments.length
        },
      ]
    },
    chartOptions() {
      let total = this.series.reduce((a, b) => a + b, 0) || 0,
        formed_total = val => this.formatNumber(val) + (this.top_by == 'summ' ? ' ' + this.$t('Tenders.hrn') : '')
      let options = {
        chart: {
          offsetX: 0,
          type: 'donut',
        },
        noData: {
          text: `${this.$t('Common.NoDataInCurrentDateRange')}.`,
          align: 'center',
          verticalAlign: 'middle',
          style: {
            color: 'var(--black-color)',
            fontSize: '24px',
            fontFamily: 'IBM Plex Sans, sans-serif',
          }
        },
        states: {
          active: {
            allowMultipleDataPointsSelection: false,
            filter: {
              type: 'none',
            }
          },
        },
        tooltip: {
          enabled: false,
        },
        stroke: {
          width: 1,
          colors: ['var(--v-main__light_green-base)']
        },
        dataLabels: {
          enabled: false,
        },

        colors: [ 'var(--secondary__yellow_chosen)', '#F7BC8D', '#50ccc4', '#cfc623', 'var(--color-info)', '#63b090', 'var(--color-error)', '#FFB9AA', '#5ebf79','#f7c33b' ],
        labels: this.categories.map(cat => cat.name) ,
        legend: {
          onItemClick: {
            toggleDataSeries: false
          },
          // position: 'left',
          show: true,
          fontWeight: 400,
          fontSize: '14px',
          fontFamily: 'IBM Plex Sans, sans-serif',
          color: 'var(--black-color)',
          formatter: function(seriesName, opts) {
            let item  = opts.w.globals.series[opts.seriesIndex] || 0,
              percent = +( ( (item  / total) || 0) * 100 )?.toFixed(2)
            return `<div class="ml-2 flex flex-between">
              <div class="text-start flex my-auto" data-qa="series-${seriesName}-amount" >
                <span class="h8-text-bold series-summ" data-qa="series-${seriesName}-summ">${formed_total(item)}</span>
                <span class="h8-text series-percent" data-qa="series-${seriesName}-percent">(${ percent }%)</span>
              </div>
              <div class="h8-text ml-5 black--text text-left"> ${seriesName} </div>
            </div> `
          },
          markers: {
            width: 0,
            height: 0,
          }
        },
        plotOptions: {
          pie: {
            expandOnClick: false,

            dataLabels: {
              show: false,
            },
            donut: {
              size: '50%',
              labels: {
                show: true,
                value: {
                  show: true,
                  fontWeight: 400,
                  fontSize: '14px',
                  fontFamily: 'IBM Plex Sans, sans-serif',
                  color: 'var(--black-color)',
                },
                total: {
                  fontWeight: 600,
                  fontSize: '20px',
                  fontFamily: 'IBM Plex Sans, sans-serif',
                  show: true,
                  showAlways: true,
                  label: formed_total(total),
                  color: 'var(--black-color)',
                  formatter: () => '100%'
                }
              }
            }
          }
        },
      }
      return options
    },
    series() {
      return this.categories.map(cat => cat[this.top_by])
    },
    donutMfPayload() {
      let total = this.series.reduce((a, b) => a + b, 0) || 0,
        formed = val => this.formatNumber(val) + (this.top_by == 'summ' ? ' ' + this.$t('Tenders.hrn') : '')
      return {
        kind: 'donut',
        variant: 'withPercent',
        labels: this.categories.map(cat => cat.name),
        series: this.series,
        displayValues: this.series.map(formed),
        totalLabel: formed(total),
        colors: [ 'yellow-chosen', '#F7BC8D', '#50ccc4', '#cfc623', 'info', '#63b090', 'error', '#FFB9AA', '#5ebf79', '#f7c33b' ],
        strokeColor: 'main-light-green',
        tooltipEnabled: false,
      }
    },
    breadcrumbs() {
      return [
        {
          text: this.$t('Menu.CRMSuppliers'),
          action: () => {},
          to: {name: 'suppliers'}
        },
        {
          text: this.item.organizationTitle ,
          loading: this.loading
        },
      ]
    },
  },
  methods: {
    showDecisionForm(onlyFiles) {
      this.decisionForm.onlyFiles = onlyFiles
      this.decisionForm.show = true
    },
    async getItem() {
      this.loading = true
      await this.$store.dispatch('getTenderSupplierWithVerification', +this.$route.params.id ).then(res => {
        if (!res ) {
          this.$router.push({name: 'page-error', params: { status_code: 404, descript: 'Supplier'}})
        }
        this.item = res
      })
      this.loading = false
    },
    async getParticipationByTenderCategory() {
      this.loading = true
      await this.$store.dispatch('getParticipationByTenderCategory', {
        supplierOrganizationId: this.item.supplierOrganizationId,
        participationDateFrom: this.period[0] ? this.$moment( this.period[0]).format('YYYY-MM-DDTHH:mm:ss') : this.period[0] ,
        participationDateTo: this.period[1] ? this.$moment( this.period[1]).format('YYYY-MM-DDTHH:mm:ss') : this.period[1] }).then(res => {

        let groups = this.$_.groupBy( res, 'categoryCode' )
        groups = Object.entries( groups ).map(([code, items]) => {
          return {
            name: `${items[0].categoryName} (${code})`,
            summ: items.reduce((a, b) => a + b.bidSumTotal, 0),
            quantity: items.length
          }
        })
        this.categories = this.$_.take(this.$_.reverse(this.$_.sortBy(groups, this.top_by)), 10)
      }).finally(() => this.loading = false)
    },
    changeTop(val) {
      this.categories = this.$_.take(this.$_.reverse(this.$_.sortBy( this.categories, val)), 10)
    },
    deleteFile({ file }) {
      this.attachments = this.attachments.filter(f => f.key !== file.key)
    },
    addedNewFile(file) {
      this.attachments.unshift(file)
    },
    fetchAttachments() {
      files_api.getFileList(this.item.supplierOrganizationId, 'Crm')
        .then((res) => {
          res = res ?? []
          const files = res.map((file) => {
            const fileConvert = {
              title: file.fileName,
              size: file.size,
              key: file.id,
              created: file.modifier?.userName ?? '-',
              ...file
            }
            return new StorageFile(this.item.supplierOrganizationId, fileConvert, 'Crm')
          })
          this.attachments = files.sort((a, b) => new Date(b.dateModified) - new Date(a.dateModified))
        })
    },
  },
  components: {
    MenuItem,
    EmptyBlock,
    StatusChip,
    Breadcrumbs,
    DocumentList,
    RatingDialog,
    SupplierOnSite,
    ApexChartDonut,
    SpilkaChartsMF,
    SupplierOffers,
    SupplierRating,
    SupplierTenders,
    SupplierContactPeople,
    DateRangeDialogWithType,
    ComponentsLayoutWithNavbar,
    SupplierInspectionDecisionModal
  }
}
</script>
<style lang="scss">
.span.h8-text-bold.series-summ {
  white-space: nowrap;
  margin: auto 0;
}
</style>
<style lang="scss" scoped>
.span.h8-text-bold.series-summ {
  white-space: nowrap;
  margin: auto 0;
}
.tab {
  &__badge {
    position: relative;
    bottom: 5px;
    left: 4px;
  }
}
.bi-tab_card {
  border-radius: 12px;
}
.supplier-info {
  height: 100%;
}
</style>
<style lang="scss">
#components-layout-supplier-item {
  .apexcharts-legend.apexcharts-align-center {
    width: 60%; // calc(100% - 300px);
    max-width: 600px; // calc(100% - 300px);
    top: 0 !important;
  }
  .v-data-table {
    tr {
      td:first-child, th:first-child {
        padding-left: 10px !important;
      }
      td:last-child, th:last-child {
        padding-right: 20px !important;
      }
    }
  }
}
</style>
